import BaseModalView from "scripts/views/baseModalView";
import { selectedTerms } from "scripts/views/search/facetMapper";
import templateFacetedSearchCheckboxMultiSelectModal from "templates/search/facetedSearchCheckboxMultiSelectModal.hbs";

class FacetedSearchCheckboxMultiSelectModalView extends BaseModalView {
  get events() {
    return {
      "click #bb-faceted-search-facet-modal-apply-button": "onClickApply",
    };
  }

  get className() {
    return "modal-content faceted-search-modal";
  }

  get template() {
    return templateFacetedSearchCheckboxMultiSelectModal;
  }

  render() {
    const facetLabel = this.model.get("facetLabel");
    const terms = selectedTerms(
      this.model.get("facetValues"),
      this.model.get("chosenTermCodes"),
    );

    this.$el.html(
      this.template({
        facetLabel,
        terms,
      }),
    );

    return this;
  }

  onClickApply() {
    const termCodes = $(".faceted-search-modal-checkbox")
      .toArray()
      .map(checkbox => {
        if (checkbox.checked) {
          return checkbox.value;
        } else {
          return null;
        }
      })
      .filter(o => o);

    this.trigger("apply", this.model.get("facetParam"), termCodes);
  }
}

export default FacetedSearchCheckboxMultiSelectModalView;
